import ResourceAPI, { Resource, SearchParams } from 'api/ResourceAPI';
import { handleApiError } from './errors';
import { PostBLBulkOrderWorkunitsWorkunits } from './OrderWorkunitApiService';
import Order from 'types/entities/Order';
import axios, { AxiosResponse } from 'axios';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import { SelectedFiltersList } from 'types/models/SelectedFiltersList';
import Scope from 'types/entities/Scope';
// import { AxiosResponse } from 'axios';
// import HelpMenuListVideos from 'types/entities/HelpMenuVideos';
// import Category from 'types/entities/VideoCategory';
// import HelpMenuUserGuide from 'types/entities/HelpMenuUserGuide';

export type PostBulkOrderWorkunitsWorkunits = {
  workunit_id: number;
  delivery_date: string;
  scope_id: Scope['id'] | null;
  purchase_order_id: number | null;
  workunit_name: string;
  purchase_order: string | number | null;
  workunit_reference: string;
  content: string;
  content2: string;
  content3: string;
  content4: string;
  content5: string;
  qte: number;
  workunit_complexity_id: number | null;
}[];

export default class ChangeBaseLineAPIServices {
  // static postBulkBLOrderWorkunits(arg0: {
  //   order_baseline_id: Order['id'];
  //   source_order_id: Order['id'];
  //   page_typeid: number;
  //   order_workunits: PostBulkOrderWorkunitsWorkunits;
  // }): Promise<any> {
  //   throw new Error('Method not implemented.');
  // }
  public static instance: ChangeBaseLineAPIServices;

  public static orderBaseLineUrl = 'orders/baseline' as Resource;

  public static get Instance() {
    // eslint-disable-next-line no-return-assign
    return ChangeBaseLineAPIServices.instance || (ChangeBaseLineAPIServices.instance = new ChangeBaseLineAPIServices());
  }

  public static async createEngagementparameter(data: any) {
    try {
      const res = await ResourceAPI.post(this.orderBaseLineUrl, data);
      return res.data;
    } catch (error: unknown) {
      handleApiError(error);
      return null;
    }
  }

  public static async postBulkBLOrderWorkunits(body: {
    order_baseline_id: Order['id'];
    source_order_id: Order['id'];
    page_typeid: number;
    order_workunits: PostBLBulkOrderWorkunitsWorkunits;
    baseline_version: number;
  }): Promise<AxiosResponse<any> | null> {
    try {
      const req = ResourceAPI.post(this.orderBaseLineUrl, body);
      return await req;
    } catch (error) {
      handleApiError(error);
      return null;
    }
  }

  public static async getOrderNewWorkunitInOrder(
    baselineOrder_id: number,
    page_typeid: number,
    order_source_id: number,
    baseline_version: number
  ) {
    try {
      const { data } = await ResourceAPI.get(
        `${this.orderBaseLineUrl}?order_baseline_id=${baselineOrder_id}&page_typeid=2
        &source_order_id=${order_source_id}&baseline_version=${baseline_version}` as Resource,
        {}
      );
      return data;
    } catch (error: unknown) {
      if (axios.isCancel(error)) {
        return { datas: null, totalPage: 0, totalItems: 0, currentPage: 0 };
      }
      return { datas: [], totalPages: 0, currentPage: 0, totalItems: 0 };
    }
  }

  public static async fetchBaseLineAffectationMissions(id: number, page_typeid: number, searched: SearchParams) {
    try {
      const { data } = await ResourceAPI.get(
        `orders/baseline?order_baseline_id=${id}&page_typeid=${page_typeid}` as Resource,
        searched
      );
      return data;
    } catch (error) {
      handleApiError(error);
      return [];
    }
  }

  public static async updateBaseLineWorkunit(
    order_baseLine_id: number,
    workunit: Partial<OrderWorkunit>,
    action_id?: number
  ) {
    try {
      const payload = action_id !== undefined ? { ...workunit, action_id } : workunit;
      const { data } = await ResourceAPI.post(`orders/baseline` as Resource, payload);

      return data?.order_workunit;
    } catch (error: unknown) {
      throw Error('Unable to save workunit');
    }
  }

  public static async bulkUpdate(
    baseLinePara: any,
    missionIds: number[],
    updatedContent: Partial<OrderWorkunit>,
    selectAll: boolean,
    filters?: SelectedFiltersList
  ) {
    try {
      const toSend: {
        ressources?: number[];
        data: Partial<OrderWorkunit>;
        // modification_reason: string | null;
        page_typeid: number;
        order_baseline_id: number;
        source_order_id: number;
        workunit_type: string;
        baseline_version?: number;
        default_delivery_manager_id?: number;
        filters?: {
          select_all: boolean;
        };
      } = {
        data: updatedContent,
        page_typeid: baseLinePara?.page_typeid,
        workunit_type: baseLinePara?.workunit_type,
        order_baseline_id: baseLinePara?.order_baseline_id,
        source_order_id: baseLinePara?.source_order_id,
        // modification_reason: modificationReason ?? ' ',
        filters: {
          ...filters,
          select_all: selectAll,
        },
      };
      if (missionIds.length > 0) {
        toSend.ressources = missionIds;
      }
      toSend.baseline_version = baseLinePara?.baseline_version;
      toSend.default_delivery_manager_id = baseLinePara?.default_delivery_manager_id;
      const { data } = await ResourceAPI.post(`orders/baseline` as Resource, toSend);

      return data;
    } catch (error) {
      handleApiError(error);
      return {};
    }
  }

  public static async fetchBaselineOrderSummary(order_baseline_id: Order['id']) {
    try {
      const { data } = await ResourceAPI.get(
        `orders/baseline?order_baseline_id=${order_baseline_id}&page_typeid=4` as Resource
      );
      return data;
    } catch (error) {
      handleApiError(error);
      return [];
    }
  }

  public static async fetchOrderScopeBLById(order_baseline_id: number, searchParams?: SearchParams) {
    try {
      // const { data } = await ResourceAPI.get(this.baseUrl, {
      //   order_id: orderId,
      //   size: '-1',
      //   ...searchParams,
      // });
      const { data } = await ResourceAPI.get(
        `orders/baseline?order_baseline_id=${order_baseline_id}&join=scope&page_typeid=4` as Resource
      );

      return data.rows;
    } catch (error: unknown) {
      return [];
    }
  }

  public static async cancelBaseLineMissions(body: {
    source_order_id: Order['id'];
    page_typeid: number;
    baseline_version: number;
    is_cancelled: number;
  }) {
    try {
      const { data } = await ResourceAPI.post(this.orderBaseLineUrl, body);

      return data;
    } catch (error) {
      handleApiError(error);
      return null;
    }
  }

  public static async postSubmitBaseline(body: {
    source_order_id: Order['id'];
    page_typeid: number;
    order_baseline_id: number;
    baseline_version: number;
  }) {
    try {
      const { data } = await ResourceAPI.post(this.orderBaseLineUrl, body);
      return data;
    } catch (error) {
      handleApiError(error);
      return null;
    }
  }

  public static async fetchParamsBLFilter(
    source_order_id: Order['id'],
    order_baseline_id: number,
    baseline_version: number
  ) {
    try {
      const {
        data: {
          'filter-params': { scopes, consultants, clients, delivery_managers, purchase_orders, workunit_reference },
        },
      } = await ResourceAPI.get(
        `orders/baseline/general?order_baseline_id=${order_baseline_id}
        &page_typeid=3&source_order_id=${source_order_id}&baseline_version=${baseline_version}` as Resource
      );
      return { scopes, consultants, clients, delivery_managers, purchase_orders, workunit_reference };
    } catch (error) {
      handleApiError(error);
      return [];
    }
  }
}
